import React from 'react';
import { APIClients, ApiClientType, IntegrationsAPIClient } from '@futrli/shared-services';
import { INTERNAL_USER_ID_QUERY_PARAM } from '@futrli/shared-services/api-client/api-client';
import { RenderReportPage } from '@futrli/predict';

import { getSearchParam } from '../utils/urls';
import { LDProvider } from '../core/providers/launch-darkly';
import { NotFound } from '../errors/components/not-found';

export const AppRenderReport = () => {
  const userId = getSearchParam(INTERNAL_USER_ID_QUERY_PARAM);

  if (userId) {
    APIClients.setApiClient(ApiClientType.Aws);
    IntegrationsAPIClient.setApiClient(ApiClientType.Aws);

    return (
      <LDProvider>
        <RenderReportPage />
      </LDProvider>
    );
  } else {
    return <NotFound />;
  }
};
